import { render, staticRenderFns } from "./KouzuiLayer.vue?vue&type=template&id=3e7f20da&scoped=true&"
import script from "./KouzuiLayer.vue?vue&type=script&lang=js&"
export * from "./KouzuiLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7f20da",
  null
  
)

export default component.exports